import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.neutralLighterAlt,
    padding: 15,
  },
}));
